import {DraggableTree} from 'vue-draggable-nested-tree'
import Info from '../view/info'
import Helper from './helper'
import lodash from 'lodash'
import TableItem from './table-item'
import swal from 'sweetalert'
import CopyChecklist from './copy-checklist'
export default {
  name: 'checklist-item',
  components: {Tree: DraggableTree, Info, TableItem, CopyChecklist},
  props: [],
  data () {
    return {
      loading: false,
      group_checklist_items: [],
      normalizer (node) {
        return {
          id: node.id,
          label: node.index + node.header,
          children: node.children
        }
      },
      chooice: [],
      select_group: {}
    }
  },
  computed: {
    data () {
      return this.$store.getters['GroupChecklistItem/getListGroupChecklistItem']
    },
    checklist () {
      return this.$store.getters['Checklist/showChecklist']
    },
    checklist_users () {
      return this.$store.getters['Audit/getUserOfChecklist']
    },
    // chooice () {
    //   return this.$store.getters['Checklist/getGroupOfChecklist']
    // }
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    },
  },
  mounted () {
    // this.loading = true
    this.$loading.start()
    Promise.all([
      this.data.length == 0 ?this.$store.dispatch('GroupChecklistItem/getListGroupChecklistItem', {page: 1, per_page: 'all'}):'',
      this.$store.dispatch('Checklist/showChecklist', {checklist: {id: this.$route.params.checklist_id}}),
      this.$store.dispatch('Audit/getUserOfChecklist', {checklist: {id: this.$route.params.checklist_id}}),
      this.$store.dispatch('Checklist/duplicateChecklist', {checklist: {id: this.$route.params.checklist_id}})
    ]).then(res => {
      this.data2 = []
      var tam = [...res[0]]
      tam.forEach(element => {
        this.data2.push(Object.assign({}, element))
      })
      // console.log(this.data)
      // this.loading = false
      this.$loading.complete()
      this.chooice = this.$store.getters['Checklist/getGroupOfChecklist']
    }).catch(errors => {
      console.log(errors)
      // this.loading = false
      this.$loading.fail()
    })
  },
  methods: {
    select (data) {
      this.select_group = {}
      this.$loading.start()
      this.$store.dispatch('GroupChecklistItem/showGroupChecklistItem', {group_checklist_item: data, status: this.$status.APPROVAL}).then(res => {
        var parent = []
        var chooice = []
        this.data.forEach(element => {
          parent = parent.concat(Helper.getUnNestedChildren(element))
        })
        this.chooice.forEach(element => {
          chooice = chooice.concat(Helper.getUnNestedChildren(element))
        })
        var tam = lodash.orderBy(Helper.getDiff(Helper.getParent(res.id, parent).concat(Helper.getUnNestedChildren(res)), chooice), 'id')
        this.chooice = Helper.getNestedChildren(tam, 0)
        this.$loading.complete()
      }).catch(errors => {
        console.log(errors)
        this.$loading.fail()
      })
    },

    selectChecklistItem (data) {
      this.select_group = data
    },

    removeGroup (data) {
      this.select_group = {}
      var chooice = []
      this.chooice.forEach(element => {
        chooice = chooice.concat(Helper.getUnNestedChildren(element))
      })
      var index = lodash.findIndex(chooice, ['id', data.id])
      chooice.splice(index, 1)
      this.chooice = Helper.getNestedChildren(chooice, 0)
    },

    info () {
      this.select_group = {}
    },

    destroyItem (item) {
      var index = lodash.findIndex(this.select_group.chk_items, ['id', item.id])
      var tamp = this.select_group.chk_items[index]
      item.destroy = true
      this.select_group.chk_items.splice(index, 1, tamp)
    },

    addItemSuccess (items) {
      this.select_group.chk_items = items
    },

    addItem (item) {
      var index = lodash.findIndex(this.select_group.chk_items, ['id', item.id])
      var tamp = this.select_group.chk_items[index]
      item.destroy = false
      this.select_group.chk_items.splice(index, 1, tamp)
    },

    copyChecklist () {
      // this.loading = true
      this.$loading.start()
      Promise.all([
        // this.$store.dispatch('Checklist/getListChecklist', {page: 1, per_page: 100}),
        this.organizations.length ==0 ?this.$store.dispatch('Organization/getData', {page: 1, per_page: 'all'}): ''
      ]).then(res => {
        this.$refs.copyChecklistShow.show()
        // this.loading = false
        this.$loading.complete()
      }).catch(errors => {
        // this.loading = false
        this.$loading.fail()
      })
    },

    copy (checklist) {
      // this.loading = true
      this.$loading.start()
      this.$store.dispatch('Checklist/duplicateChecklist', {checklist}).then(res => {
        this.chooice = this.$store.getters['Checklist/getGroupOfChecklist']
        // this.loading = false
        this.$refs.copyChecklistShow.hide()
        this.$loading.complete()
      }).catch(errors => {
        // this.loading = false
        this.$loading.fail()
      })
    },

    save () {
      var groups = []
      var items = []
      this.chooice.forEach(element => {
        groups = groups.concat(Helper.getUnNestedChildren(element))
      })
      groups.forEach(element => {
        if (element.chk_items) {
          Object.values(element.chk_items).forEach(item => {
            if (!item.destroy) {
              items.push(item.id)
            }
          })
        }
      })
      if (items.length) {
        this.$loading.start()
        // this.loading = true
        this.$store.dispatch('Checklist/addChecklistItem', {checklist: this.checklist, checklist_items: items}).then(res => {
          this.$loading.complete()
          // this.loading = false
          this.$notify({
            group: 'success',
            title: this.$t('notify.notify'),
            text: this.$t('notify.update_success')
          })
          this.$router.push('/checklist/list')
        }).catch(errors => {
          this.$loading.fail()
          // this.loading = false
        })
      } else {
        swal({
          title: 'Checklist rỗng bạn có chắc chắn muốn thoát ?',
          icon: 'warning',
          buttons: true,
          dangerMode: true
        }).then((willDelete) => {
          if (willDelete) {
            this.$router.push('view')
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/checklist-item/checklist-item.js